import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Anchor = types.compose(
  BaseEntity,
  types.model('Anchor', {
    anchorId: types.identifierNumber,
    name: types.string,
    radius: types.maybe(types.number),
    latitude: types.maybe(types.number),
    longitude: types.maybe(types.number),
  }),
);
